module.exports = "/_next/static/images/meesho-1e1c87bf62a7ca0f1fb130436ad95c8c.png";